import React from 'react'
import { Select, Form, Icon, Input, DatePicker, Radio } from 'antd';

import PatientElectronicText from './Texts/PatientElectronicText';
import SurrogateElectronicText from './Texts/SurrogateElectronicText';

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    return (
      <div className="form-group">
        <h4>{props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'}</h4>

        <div className="form-group-details">
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.consentPersonType === 'Surrogate' ? <SurrogateElectronicText {...props} /> :
          <PatientElectronicText {...props} />}

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <Form.Item>
          <div className='form-label'>Do you understand that you have been asked to be in a research study?</div>
          {props.form.getFieldDecorator('pcf_question_1', {
            initialValue: props.pcf_question_1,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Have you read and received a copy of the attached Information Sheet?</div>
          {props.form.getFieldDecorator('pcf_question_2', {
            initialValue: props.pcf_question_2,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Do you understand the benefits and risks involved in taking part in this research
            study?
          </div>
          {props.form.getFieldDecorator('pcf_question_3', {
            initialValue: props.pcf_question_3,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Have you had an opportunity to ask questions and discuss this study?</div>
          {props.form.getFieldDecorator('pcf_question_4', {
            initialValue: props.pcf_question_4,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Do you understand that you are free to withdraw from the study at any time,
            without having to give a reason and without affecting your future medical care?
          </div>
          {props.form.getFieldDecorator('pcf_question_5', {
            initialValue: props.pcf_question_5,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Has the issue of confidentiality been explained to you?</div>
          {props.form.getFieldDecorator('pcf_question_6', {
            initialValue: props.pcf_question_6,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Do you understand who will have access to your records, including personally
            identifiable health information?
          </div>
          {props.form.getFieldDecorator('pcf_question_7', {
            initialValue: props.pcf_question_7,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>Do you want the investigator(s) to inform your family doctor that you are
            participating in this research study?
          </div>
          {props.form.getFieldDecorator('pcf_question_8', {
            initialValue: props.pcf_question_8,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        {props.form.getFieldValue('pcf_question_8') === 'true' && <Form.Item>
          <div className='form-label'>Your family doctor's name</div>
          {props.form.getFieldDecorator('pcf_question_8_name', {
            initialValue: props.pcf_question_8_name,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Input/>
          )}
        </Form.Item>}

        <Form.Item>
          <div className='form-label'>Who explained this study to you?</div>
          {props.form.getFieldDecorator('pcf_question_9_who', {
            initialValue: props.pcf_question_9_who,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Input/>
          )}
        </Form.Item>

        <Form.Item>
          <div className='form-label'>I agree to take part in this study:</div>
          {props.form.getFieldDecorator('pcf_question_10_agree', {
            initialValue: props.pcf_question_10_agree,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Radio.Group>
              <Radio value='true'>Yes</Radio>
              <Radio value='false'>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item>
          <label>
            <div className='form-label'>Research Subject Name</div>
            {props.form.getFieldDecorator('pcf_research_subject_name', {
              initialValue: props.pcf_research_subject_name || props.dc_patient_name,
              rules: [{
                required: true,
                message: 'Required'
              }],
            })(
              <Input
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Research Subject Name"
              />
            )}
          </label>
        </Form.Item>

        {props.consentMethodType === 'Email' && <Form.Item>
          {props.form.getFieldDecorator('pcf_participant_email', {
            initialValue: props.pcf_participant_email,
            rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
          })(
            <Input disabled placeholder="Participant Email"/>
          )}
        </Form.Item>}

        {/*<Form.Item>
          <div className='form-label'>Date of birth</div>
          {props.form.getFieldDecorator('dateOfBirth', {
            rules: [{
              required: false,
              message: 'Please select your Date of Birth'
            }],
          })(
            <DatePicker
              id="dateOfBirth"
              name="dateOfBirth"
              placeholder="Date of Birth (optional)"
              allowClear
            />
          )}
        </Form.Item>*/}

        {props.consentPersonType === 'Surrogate' && <Form.Item>
          <div className='form-label'>Witness (to SDM)</div>

          {props.form.getFieldDecorator('pcf_witness_to_sdm', {
            initialValue: props.pcf_witness_to_sdm,
            rules: [{
              required: true,
              message: 'Required'
            }],
          })(
            <Input/>
          )}
        </Form.Item>}

        {/*<Form.Item>
          <label>Date and time</label>
          <div style={{ display: 'flex', alignItems: 'center', maxWidth: '400px' }}>
            {props.form.getFieldDecorator('pcf_witness_datetime', { rules: [{ required: true, message: 'Required' }] })(
              <DatePicker
                placeholder="yyyy-mm-dd"
                format='YYYY/MM/DD HH:mm'
                showTime={{ format: 'HH:mm' }}
              />,
            )}

            &nbsp;{props.userShortTimezone || 'UTC'}
          </div>
        </Form.Item>*/}

        {props.consentPersonType === 'Surrogate' && <Form.Item>
          <label>
            <div className='form-label'>Decision maker relationship</div>
            {props.form.getFieldDecorator('pcf_relationship_to_participant', {
              initialValue: props.pcf_relationship_to_participant,
              rules: [{
                required: true,
                message: 'required'
              }],
            })(<Input/>)}
          </label>
        </Form.Item>}

        <Form.Item>
          <label>
            <div className='form-label'>Do you consent to the terms described above?</div>
            {props.form.getFieldDecorator('consent_provided', {
              initialValue: props.consent_provided,
              rules: [{
                required: true,
                message: 'Do you consent to the terms described above?'
              }],
            })(
              <Select>
                <Option value="yes">Yes</Option>
                <Option value="">No</Option>
              </Select>
            )}
          </label>
        </Form.Item>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLethbridge/Step3aPatient.js